import { useTranslation } from "react-i18next";
import { StyledHeader } from "./styles"
import clsx from "clsx";
import { LanguageSelect } from "./LanguageSelect/LanguageSelect";
import { StagesBreadcrumbs } from "./StagesBreadcrumbs/StagesBreadcrumbs";
import { useNavigate } from "react-router-dom";

export const Header = () => {
  return (
    <StyledHeader>
      <div className="title">
        Jukebox
      </div>
      <StagesBreadcrumbs />
      <div className="menu">
        <LanguageSelect />
      </div>
      </StyledHeader>
  )
}
